import { gql } from 'apollo-boost';

export const FIND_PARTNERSHIP_BY_ID = gql`
  query doFindPartnershipById($id: ID!) {
    findPartnershipById(id: $id) {
      id
      company
      members {
        id
        firstName
        lastName
        email
      }
      clinics {
        clinic {
          title
          address1
          address2
          city
          zip
          state
          country
          phone
        }
      }
    }
  }
`;
